import {
  MedicalProvider,
  ProviderTreatmentStatus,
} from '@/services/types/treatment-types';

export const getProviderTreatmentDates = (
  provider: MedicalProvider,
): { startingDate: Date | undefined; endingDate: Date | undefined } => {
  const filteredEncounters =
    provider.encounters?.filter((encounter) => encounter.date !== null) ?? [];
  const sortedEncounters = filteredEncounters?.sort(
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (a, b) => new Date(a.date!).getTime() - new Date(b.date!).getTime(),
  );

  const startingDate = sortedEncounters?.[0]?.date
    ? new Date(sortedEncounters[0].date)
    : undefined;
  const endingDate = sortedEncounters?.[sortedEncounters.length - 1]?.date
    ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      new Date(sortedEncounters[sortedEncounters.length - 1].date!)
    : undefined;

  return {
    startingDate,
    endingDate,
  };
};

export const formatProviderTreatmentDates = (
  treatmentStatus: ProviderTreatmentStatus,
  startingDate: Date | undefined,
  endingDate: Date | undefined,
) => {
  const isTreatmentInProgress =
    treatmentStatus === ProviderTreatmentStatus.TREATING ||
    treatmentStatus === ProviderTreatmentStatus.DEVIATING;

  if (isTreatmentInProgress && startingDate) {
    return `${startingDate?.toLocaleDateString()} - Present`;
  }

  if (startingDate && endingDate) {
    return `${startingDate?.toLocaleDateString()} - ${endingDate?.toLocaleDateString()}`;
  }

  if (startingDate) {
    return `${startingDate?.toLocaleDateString()} - Unknown`;
  }

  if (endingDate) {
    return `Unknown - ${endingDate?.toLocaleDateString()}`;
  }

  return 'Unknown';
};
